module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8AgMAAABHkjHhAAAAAXNSR0IArs4c6QAAAAxQTFRFAAAAjI+diYyciYyci9gq/wAAAAN0Uk5TAEnj4s6DUAAAAExJREFUKM9jYBgugHH/ExQ+0/8fKHzm/3+GLp/t/wQUPvf/Byh8/v8fBo4v/c8Bha//vwGFb///wIDyge4BhhciPQDdCwxP9PQyNAEArxyH0+ewUI0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu/statistics.png
// module id = XO2L
// module chunks = 1